import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

class Spider extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                polar: true,
                type: 'line',
                height: 650,
                width: 980,
                marginBottom: 0,
                marginLeft: 0,
            },
            xAxis: {
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '10pt',
                    },
                    distance: 50,
                },
                gridLineColor: '#C8C8C8',
                lineWidth: 0,
                tickmarkPlacement: 'on'
            },
            yAxis: {
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '11pt'
                    }
                },
                gridLineColor: '#C8C8C8',
                min: 0,
                max: 6,
                tickInterval: 1,
                lineWidth: 0,
                gridLineInterpolation: 'polygon',
                showLastLabel: true
            },
            plotOptions: {
                line: {
                    pointPlacement: 'on',
                    dataLabels: {
                        enabled: true,
                        color: '#3366cc',
                        align: 'center',
                        allowOverlap: true,
                        x: 10,
                    }
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Spider)
}